// This file is generated by a script and should not be modified directly.
const markdown: string =
  "This element groups the different means of application offered to candidates.\n\n- URL to redirect the candidate to apply\n- Phone number of the person in charge of recruitment\n- Email of the person in charge of recruitment. This email will not be visible to the candidate.\n"
export default markdown
